import { UserSettingsContent } from '../../components/UserSettingsComponents/UserSettingsContent';
import { useOutlook } from '../../hooks';
import { StyledUserSettingsPage } from './UserSettingsPage.styles';

const UserSettingsPage = () => {
    useOutlook('user');
    return (
        <StyledUserSettingsPage>
            <UserSettingsContent />
        </StyledUserSettingsPage>
    );
};

export default UserSettingsPage;
